let currentMenuStateFn: (() => void) | undefined = undefined;

export function registerMenuCloser(fn: () => void) {
  if (currentMenuStateFn) {
    currentMenuStateFn();
  }
  currentMenuStateFn = fn;
}

export function clearMenuCloser() {
  currentMenuStateFn = undefined;
} 